// Card details a user can hide. Stored per browser, like a display preference.
export const cardFields = [
  ['board', 'Bronbord'], ['bucket', 'Bucket'], ['assignees', 'Toegewezen'], ['priority', 'Prioriteit'], ['deadline', 'Deadline'],
  ['labels', 'Labels'], ['checklist', 'Checklist'], ['attachments', 'Bijlagen'], ['start', 'Startdatum'], ['overlap', 'Overlap tussen borden'],
]
export const allCardFields = Object.fromEntries(cardFields.map(([key]) => [key, true]))
